<div class="no-access">
  <img class="no-access__img" src="/assets/icons/error-background.png" alt=""/>
  <div class="no-access__title">Sorry, you do not have access to this application</div>
</div>
